import {
  BtnContainer,
  ButtonRedireccion,
  CruzContainer,
  Header,
  ModalBody,
  RedireccionContainer,
} from "./localStyle";

const OrdenTurno = ({ dissmiss, pedirClave, recepcionarse }) => {
  const onClickBtn = (e) => {
    dissmiss();
    if (e) {
      recepcionarse();
    } else {
      setTimeout(() => {
        pedirClave();
      }, 100);
    }
  };

  return (
    <RedireccionContainer>
      <Header>
        <span className="rb16m c-white" style={{ paddingRight: "20px" }}>
          Atención
        </span>
        <CruzContainer onClick={dissmiss}>
          <div className="line1"></div>
          <div className="line2"></div>
        </CruzContainer>
      </Header>
      <ModalBody>
        <span className="rb16l c-black">
          Tenés turnos para hoy y también órdenes que todavía no tienen un turno
          asignado.
        </span>
        <span className="rb16l c-black">
          ¿Querés recepcionar tus turnos o reservar turno para tus órdenes?
        </span>
        <BtnContainer>
          <ButtonRedireccion
            onClick={() => onClickBtn(false)}
            className="bgc-latex30 pointer rb16m c-white"
          >
            Reservar turno
          </ButtonRedireccion>
          <ButtonRedireccion
            onClick={() => onClickBtn(true)}
            className={"bgc-primary pointer rb16m c-white"}
          >
            Recepcionar turnos
          </ButtonRedireccion>
        </BtnContainer>
      </ModalBody>
    </RedireccionContainer>
  );
};

export default OrdenTurno;
